import { FC, Fragment, ReactNode } from "react";
import PropTypes from "prop-types";
import { Navigate } from "react-router-dom";
import useAuth from "src/hooks/useAuth";

interface GuestGuardProps {
  children?: ReactNode;
}

const GuestGuard: FC<GuestGuardProps> = ({ children }) => {
  const { isAuthenticated } = useAuth();

  if (isAuthenticated) {
    return <Navigate to="/" />;
  }

  return <Fragment>{children}</Fragment>;
};

GuestGuard.propTypes = {
  children: PropTypes.node,
};

export default GuestGuard;
